import { render, staticRenderFns } from "./EquipeView.vue?vue&type=template&id=15fdc2e6"
import script from "./EquipeView.vue?vue&type=script&lang=js"
export * from "./EquipeView.vue?vue&type=script&lang=js"
import style0 from "./EquipeView.vue?vue&type=style&index=0&id=15fdc2e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports